export enum VentilationTypeEnum {
    Mechanical = 'mechanical',
    ExhaustFan = 'exhaust_fan',
}
